module.exports = __webpack_public_path__ + "static/media/teacher9.88112bb3.png";